import { EmployeePermissions } from 'src/lib/fliko/models/company/employeeRole.data';

export function getCompanyStartPath(permissions: EmployeePermissions): string | null {
  const routes: [keyof EmployeePermissions, string][] = [
    ['c_dashboard', '/company/dashboard'],
    ['c_role', '/company/employees'],
    ['c_report', '/company/reviews'],
    ['c_calendar', '/company/calendar'],
    ['c_log', '/company/event-log'],
    ['c_settings', '/company/config']
  ];
  return routes.find(([module]) => Object.values(permissions[module] ?? {}).some((allowed) => allowed === true))?.[1] ?? null;
}
